import React, { useEffect, useMemo, useState } from 'react';
import { List } from '@alifd/next';
import moment from 'moment';
import styles from './templatePreview.module.scss';
import client from '../../../../lib/feathers';

const BroadcastTemplatePreview = (props) => {
  const { template, addTemplateContent } = props;
  const onSetStyle = (children) => {
    return (
      <div
        className={styles.showAddText}
        style={{
          display: 'flex',
          height: '100%',
          width: '100%',
          fontSize: children.textSize,
          color: children.textColor,
          fontWeight: children.textTags.indexOf('粗體') >= 0 ? '900' : 'normal',
          fontStyle:
            children.textTags.indexOf('斜體') >= 0 ? 'italic' : 'normal',
          justifyContent: children.textLevel,
          alignItems:
            (children.textVertical === 'start' && 'flex-start') ||
            (children.textVertical === 'center' && 'center') ||
            (children.textVertical === 'end' && 'flex-end'),
          overflow: 'hidden',
          backgroundImage:
            (children.typeContent === 'image' &&
              `url(${children.typeFormat})`) ||
            'none',
          backgroundSize:
            (children.textSize === 'fullVersion' && 'cover') ||
            (children.textSize === 'originalSize' && 'Contain') ||
            (children.textSize === 'repeat' && 'Contain'),
          backgroundRepeat:
            children.textSize === 'repeat' ? 'repeat' : 'no-repeat',
          backgroundPosition: children.textLevel,
        }}
      >
        {(children.typeContent === 'date' ||
          children.typeContent === 'time' ||
          children.typeContent === 'dateTime') &&
          moment(new Date()).format(children.typeFormat)}
        {children.typeContent === 'text' &&
          children.typeFormat.split('\n').map((i) => (
            <>
              {i}
              <br />
            </>
          ))}
        {children.typeContent === 'weather' && `${children.typeFormat}天氣`}
        {children.typeContent === '空氣品質' && (
          <div className={styles.immediate}>
            <div>室外PM₁.₀</div>
            <div>室外PM₂.₅</div>
            <div>室外PM₁₀</div>
            <div>室內PM₂.₅</div>
            <div>室內PM₁₀</div>
            <div>室內CO₂</div>
            <div>室內TVOC</div>
            <div>室內CH₂O</div>
          </div>
          // <div style={{ display: 'block' }}>
        )}
        {children.typeContent === '照度' && '室內照度'}
        {children.typeContent === '濕度' && '室內濕度'}
        {children.typeContent === '溫度' && '室內溫度'}
        {children.typeContent === 'youtube' && (
          <iframe
            width="100%"
            height="100%"
            src={`https://www.youtube.com/embed/${
              children.url
            }?autoplay=1&controls=0&modestbranding=1&start=${
              children.startTime
            }&end=${children.endTime + 2}&mute=${children.sound}`}
            frameBorder="0"
            allow="autoplay"
          />
        )}
        {children.typeContent === 'mp4' && (
          <video
            width="100%"
            height="100%"
            autoPlay={true}
            src={children.url.path}
            loop={true}
            muted={children.sound === 0 ? true : false}
          ></video>
        )}
        {/* {children.typeContent === 'announcement' && announcementUI(children)} */}
      </div>
    );
  };

  if (template === 'one') {
    return (
      <div className={styles.container}>
        <div className={styles.templateContent}>
          {addTemplateContent.map((item, index) => {
            return (
              <div
                key={index}
                style={{
                  width: `${item.size}%`,
                  backgroundColor: item.color,
                  height: '100%',
                  padding: addTemplateContent.full ? '0vw' : '1.6vw',
                }}
              >
                {item.children.length > 0
                  ? onSetStyle(item.children[0])
                  : '未設定內容'}
              </div>
            );
          })}
        </div>
      </div>
    );
  } else if (template === 'two') {
    return (
      <div className={styles.container}>
        <div className={styles.templateTop}>
          {addTemplateContent.map((item, index) => {
            return (
              <div
                key={index}
                className={styles.templateTwo}
                style={{
                  width: `${item.size}%`,
                  backgroundColor: item.color,
                  height: '100%',
                  padding: addTemplateContent?.full ? '0' : '1.6vw',
                }}
              >
                {item.children.length > 0
                  ? onSetStyle(item.children[0])
                  : '未設定內容'}
              </div>
            );
          })}
        </div>
      </div>
    );
  } else if (template === 'three') {
    return (
      <div className={styles.container}>
        <div className={styles.templateContent}>
          {addTemplateContent.map((item, index) => {
            return (
              <div
                key={index}
                className={styles.templateTwo}
                style={{
                  height: `${item.size}%`,
                  backgroundColor: item.color,
                  width: '100%',
                  padding: addTemplateContent?.full ? '0' : '1.6vw',
                }}
              >
                {item.children.length > 0
                  ? onSetStyle(item.children[0])
                  : '未設定內容'}
              </div>
            );
          })}
        </div>
      </div>
    );
  } else if (props.template === 'four') {
    return (
      <div className={styles.container}>
        <div className={styles.templateContent} style={{ border: 0 }}>
          <div
            className={styles.templateTop}
            style={{
              height: `${100 - addTemplateContent[2].size}%`,
              width: '100%',
              border: 0,
            }}
          >
            {addTemplateContent.map((item, index) => {
              if (index !== 2) {
                return (
                  <div
                    key={index}
                    className={styles.templateTwo}
                    style={{
                      width: `${item.size}%`,
                      backgroundColor: item.color,
                      height: '100%',
                      padding: addTemplateContent?.full ? '0' : '1.6vw',
                    }}
                  >
                    {item.children.length > 0
                      ? onSetStyle(item.children[0])
                      : '未設定內容'}
                  </div>
                );
              } else {
                return null;
              }
            })}
          </div>
          <div
            className={styles.templateBottom}
            style={{ height: `${addTemplateContent[2].size}%` }}
          >
            <div
              key={2}
              className={styles.templateTwo}
              style={{
                width: '100%',
                backgroundColor: addTemplateContent[2].color,
                height: '100%',
                padding: addTemplateContent?.full ? '0' : '1.6vw',
              }}
            >
              {addTemplateContent[2].children.length > 0
                ? onSetStyle(addTemplateContent[2].children[0])
                : '未設定內容'}
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default BroadcastTemplatePreview;
